import { styled, theme } from "@theme/stitches.config"
import * as LabelPrimitive from "@radix-ui/react-label"

export const Label = styled(LabelPrimitive.Root, {
    display: "block",
    fontSizePxToRem: 10,
    textTransform: "uppercase",
    letterSpacing: 1,
    lineHeight: "12px",
    fontWeight: theme.fontWeights.semiBold,
    color: theme.colors.text
})

export const OuterWrapper = styled("div", {

})

export const FieldWrapper = styled("div", {
    mt: 8,
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    "@lgDown": {
        width: "50%"
    },
    "@smDown": {
        width: "100%"
    }
})

export const IconWrapper = styled("div", {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img, & svg": {
        width: 14,
        height: 14
    },
    variants: {
        position: {
            left: {
                left: 12
            },
            right: {
                right: 12
            }
        },
        isPasswordType: {
            true: {
                cursor: "pointer"
            }
        }
    }
})

export const Helper = styled("small", {
    display: "block",
    mt: 10,
    color: theme.colors.N500,
    fontSizePxToRem: 12,
    mx: 10
})

export const Error = styled(Helper, {
    mt: 4,
    color: theme.colors.R500
})

export const Succes = styled(Helper, {
    mt: 4,
    color: theme.colors.G300
})
